/* -disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { performanceStatus } from '../../../../Tracking/utils/delivery-status';
import Icon from '../../../../../components/Icon';

export const statusColor = {
  [performanceStatus.ONTIME]: '#2E7D32',
  [performanceStatus.LATE_RISK]: '#E65100',
  [performanceStatus.LATE]: '#D32F2F',
}

export const HeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ alignLeft }) => (alignLeft ? 'start' : 'center')};
  justify-content: flex-start;
  font-weight: 500;
  font-size: 14px;
  height: 36px;
  color: #000000ee;

  ${({ onChangeDataOrder }) =>
    onChangeDataOrder &&
    css`
      cursor: pointer;

      &:hover {
        color: var(--luft-secondary);

        i {
          color: var(--luft-secondary);
        }
      }
  `}

  i {
    color: var(--light-opacity-gray);
  }
`;

export const BodyRow = styled.tr`
  height: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;

  ${({ hasHover, active }) =>
    hasHover &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${active
          ? '#2634650a'
          : '#2634651a'};
      }
    `}

  ${({ active }) =>
    active &&
    css`
      background-color: #2634651A;
  `}
`;

export const Divider = styled.div`
  width: 409px;
  height: 1px;
  background-color: #000000ee;
  position: absolute;
`;

export const StatusIndicator = styled.td`
  height: 100%;
  width: 4px;
  position: relative;
  right: 0px;
  background-color: ${({status}) => statusColor[status]};
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IconContainer = styled.div`
  height: 40px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIcon = styled(Icon)`
  color: #252E58;
  font-size: 20px;
  ${({ active }) => !active && css`
    filter: opacity(45%);
  `}
`;
